import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {BenefactorModel, useBenefactorById} from '../../../entities';
import * as Yup from 'yup';
import { AxiosError } from 'axios';

type UseEditBenefactorFormProps = {
  setOpen: (open: boolean) => void;
  benefactorId: string;
  benefactor?: BenefactorModel; 
};

export const useEditBenefactorForm = ({setOpen, benefactorId, benefactor}: UseEditBenefactorFormProps) => {
  const {displayNameNotRequiredSchema, realNameNotRequiredSchema} = useSchemes();
  const {updateBenefactorNamesMutation} = useBenefactorById(benefactorId);

  const onSubmit = async (values: {displayName: string, realName: string}) => {
    try {
      await updateBenefactorNamesMutation.mutateAsync({
        benefactorId, 
        displayName: values.displayName,
        realName: values.realName
      });
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      displayName: benefactor?.displayName || '',
      realName: benefactor?.realName || '',
    },
    validationSchema: Yup.object({
      displayName: displayNameNotRequiredSchema,
      realName: realNameNotRequiredSchema,
    }),
    onSubmit,
    enableReinitialize: true,
  });

  return {
    ...formik,
    isLoading: updateBenefactorNamesMutation.isPending,
    submitError: updateBenefactorNamesMutation.error ? (updateBenefactorNamesMutation.error as AxiosError<ApiError>).response?.data : undefined,
    submitForm: () => formik.handleSubmit(),
  };
}; 